import { Controller } from "@hotwired/stimulus"
import CalHeatMap from "cal-heatmap"
import Legend from "cal-heatmap/plugins/Legend"
import CalendarLabel from "cal-heatmap/plugins/CalendarLabel"
import Tooltip from "cal-heatmap/plugins/Tooltip"

export default class extends Controller {
  static values = {
    data: Array,
    employeesCount: Number,
    containerId: String,
    legendId: String,
    clickUrlBase: String,
    tooltipMissing: String,
    tooltipMissingOn: String,
    dayLabels: String,
  }

  connect() {
    this.initializeCalendar()
  }

  disconnect() {
    this.cal?.destroy()
  }

  initializeCalendar() {
    const containerId = this.containerIdValue
    const legendId = this.legendIdValue
    const employeesCount = this.employeesCountValue

    if (!containerId || !document.getElementById(containerId)) return

    const today = new Date()
    const previousMonth = new Date(today.getFullYear(), today.getMonth(), 1)

    this.cal = new CalHeatMap()

    this.cal.paint(
      {
        data: {
          source: this.dataValue,
          x: "date",
          y: "value",
          type: "json",
        },
        date: {
          weekStart: 1,
          start: previousMonth,
          locale: "de",
        },
        scale: {
          color: {
            range: ["#0ecc6d", "#ec2a2a"],
            domain: [0, employeesCount],
          },
        },
        range: 2,
        itemSelector: `#${containerId}`,
        domain: {
          type: "month",
          label: { position: "top" },
        },
        subDomain: {
          radius: 2,
          type: "day",
          width: 16,
          height: 16,
          padding: [0, 0, 0, 0],
          color: () => "black",
        },
      },
      [
        [
          Tooltip,
          {
            text: (_date, value, dayjsDate) => {
              const missingLabel = this.tooltipMissingValue || "Keine Stundenzettel"
              const missingOnLabel = this.tooltipMissingOnValue || "fehlen am"
              return (
                (value ? `${value}/${employeesCount}` : missingLabel) +
                ` ${missingOnLabel} ` +
                dayjsDate.format("LL")
              )
            },
          },
        ],
        [
          Legend,
          {
            itemSelector: `#${legendId}`,
            label: null,
            width: 100,
          },
        ],
        [
          CalendarLabel,
          {
            position: "left",
            key: "left",
            text: () => {
              const labels = this.dayLabelsValue || "Mo,Di,Mi,Do,Fr,Sa,So"
              return ["", ...labels.split(",")]
            },
            textAlign: "start",
            width: 26,
          },
        ],
      ],
    )

    this.centerCalendar()

    this.cal.on("click", (_event, timestamp) => {
      if (!this.hasClickUrlBaseValue) return

      const date = new Date(timestamp).toISOString().split("T")[0]
      const url = new URL(this.clickUrlBaseValue, window.location.origin)
      url.searchParams.set("date", date)
      window.location.assign(url.toString())
    })
  }

  centerCalendar() {
    requestAnimationFrame(() => {
      const container = document.getElementById(this.containerIdValue)
      const svg = container?.querySelector("svg")
      if (!svg) return

      svg.style.display = "block"
      svg.style.marginLeft = "auto"
      svg.style.marginRight = "auto"
      svg.style.maxWidth = "100%"
    })
  }
}
